import { LazyLoad } from 'app/utils';

export const StatementDetailPage = LazyLoad(
  () => import('./index'),
  (module) => module.StatementDetailPage,
);
